<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <path d="M32,2C14.88,2,1,15.88,1,33s13.88,31,31,31,31-13.87,31-31S49.12,2,32,2h0Z" />
    <path
      fill="#fff"
      d="M32,4.5c15.72,0,28.5,12.78,28.5,28.49s-12.78,28.51-28.5,28.51S3.5,48.71,3.5,32.99,16.29,4.5,32,4.5Z"
    />
    <path d="M32,7c-14.34,0-26,11.66-26,26s11.66,26,26,26,26-11.66,26-26S46.34,7,32,7h0Z" />
    <g>
      <rect
        style="stroke: #fff; stroke-width: 4px; stroke-miterlimit: 10; fill: none;"
        x="18.26"
        y="36.75"
        width="27.47"
        height="9"
        rx="2"
        ry="2"
      />
      <rect
        style="stroke: #fff; stroke-width: 4px; stroke-miterlimit: 10; fill: none;"
        x="36.74"
        y="18.25"
        width="9"
        height="27.5"
        rx="2"
        ry="2"
      />
      <rect
        style="stroke: #fff; stroke-width: 4px; stroke-miterlimit: 10; fill: none;"
        x="27.54"
        y="27.96"
        width="18.2"
        height="17.79"
        rx="2"
        ry="2"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AcquisitionIcon',
};
</script>
